<template>
	<div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" id="mi-modal">
		<div class="modal-dialog modal-md">
			<div class="modal-content">
				<div class="modal-header header d-flex align-items-center justify-content-between py-3 px-3">
					<h5 class="mb-0">{{ translations.are_you_sure }}</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
				</div>
				<div class="content py-2 px-3">
					<div class="table-responsive">
						<table class="table borderless registration-table">
							<tbody>
								<tr class="mt-3">
									<td class="border-0">{{ translations.company_name }}:</td>
									<td class="border-0">{{ inputs.name }}</td>
								</tr>
								<tr class="mt-3">
									<td class="border-0">{{ translations.country }}:</td>
									<td class="border-0">{{ inputs.country }}</td>
								</tr>
								<tr class="mt-3">
									<td class="border-0">{{ translations.city }}:</td>
									<td class="border-0">{{ inputs.city }}</td>
								</tr>
								<tr class="mt-3">
									<td class="border-0">{{ translations.address }}:</td>
									<td class="border-0">{{ inputs.address }}</td>
								</tr>
								<tr class="mt-3">
									<td class="border-0">{{ translations.zip }}:</td>
									<td class="border-0">{{ inputs.zip }}</td>
								</tr>
								<tr class="mt-3">
									<td class="border-0">{{ translations.phone }}:</td>
									<td class="border-0">{{ inputs.phone }}</td>
								</tr>
								<tr class="mt-3">
									<td class="border-0">{{ translations.email_form }}:</td>
									<td class="border-0">{{ inputs.email }}</td>
								</tr>
								<tr class="mt-3">
									<td class="border-0">{{ translations.web }}:</td>
									<td class="border-0">{{ inputs.web }}</td>
								</tr>
								<tr class="mt-3">
									<td class="border-0">{{ translations.gps_lat }}:</td>
									<td class="border-0">{{ inputs.gps_lat }}</td>
								</tr>
								<tr class="mt-3">
									<td class="border-0">{{ translations.gps_lon }}:</td>
									<td class="border-0">{{ inputs.gps_lon }}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="modal-footer px-3 justify-content-center">
					<button type="button" class="btn btn-outline-primary" id="modal-btn-no" @click.prevent="hideModal">{{ translations.no }}</button>
					<button type="button" class="btn btn-primary" id="modal-btn-yes" @click.prevent="sendForm">{{ translations.yes }}</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "RegistrationFormModal",
	props: ['inputs', 'translations'],
	methods: {
		sendForm() {
			$('#modal-btn-yes').attr('disabled', true)
			axios.post('/sidlo/registracia/place', this.inputs).then((response) => {
				this.$emit('submitted', response.data);
				this.hideModal();
				$('#modal-btn-yes').attr('disabled', false)
			});
		},
		hideModal() {
			$("#mi-modal").modal('hide');
		},
		getLocaleString(object, locale) {
			return object[locale] ? object[locale] : object['sk'];
		}
	}
}
</script>

<style scoped>

</style>
